import { Button, Dropdown, Icon, Input, Menu, Spin } from 'antd';
import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Pagination from '../../../../../components/Pagination/Pagination';
import useDebouncedSearch from '../../../../../hooks/useDebouncedSearch';
import usePagination from '../../../../../hooks/usePagination';
import FloorsTable from '../../../components/tables/floorsTable/FloorsTable/FloorsTable';
import ENTITY_PAGE_SIZE from '../../../constants/entityPageSize';
import useFacility from '../../../queries/useFacility';
import useFloors from '../../../queries/useFloors';
import useRooms from '../../../queries/useRooms';
import useRoomsStates from '../../../queries/useRoomsStates';
import { header } from './constants';
import queries from '../../../queries/queries';
import styles from './RoomsList.module.scss';

const RoomsList = ({ setQueryKeys }) => {
  const history = useHistory();
  const params = useParams();

  const [selectedFloor, setSelectedFloor] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  const [search, setSearch, debouncedSearch] = useDebouncedSearch();

  const { isFetching: facilityLoading } = useFacility(params.facilityId);
  const { data: rooms, isFetching: roomsLoading } = useRooms(
    params.facilityId,
    selectedState,
    debouncedSearch,
    selectedFloor
  );

  const [
    currentPageNumber,
    setCurrentPageNumber,
    maxPage,
    shownRooms,
    firstIndexOnPage,
  ] = usePagination(rooms, ENTITY_PAGE_SIZE);

  const { data: floors, isFetching: floorsLoading } = useFloors(
    params.facilityId
  );
  const { data: rentStates, isFetching: rentStatesLoading } = useRoomsStates();

  useEffect(() => {
    setQueryKeys((prev) =>
      prev.concat([
        [queries.facilityFloors, params.facilityId],
        [queries.officesStates],
      ])
    );
  }, [params.facilityId, setQueryKeys]);

  const handleStatesMenuClick = useCallback((e) => {
    setSelectedState(+e.key);
  }, []);

  const handleFloorsMenuClick = useCallback((e) => {
    setSelectedFloor(+e.key);
  }, []);
  
  const onSearchChange = useCallback((e) => setSearch(e.target.value), [setSearch]);

  const rentStatesMenu = useMemo(
    () => (
      <Menu onClick={handleStatesMenuClick}>
        {rentStates.map((rentState) => (
          <Menu.Item key={rentState.id}>{rentState.name}</Menu.Item>
        ))}
        <Menu.Item key={null}>все статусы</Menu.Item>
      </Menu>
    ),
    [rentStates, handleStatesMenuClick]
  );
  const floorsMenu = useMemo(
    () => (
      <Menu onClick={handleFloorsMenuClick}>
        {floors
          .sort((left, right) => left.floor - right.floor)
          .map((floor) => (
            <Menu.Item key={floor.floor}>{floor.floor}</Menu.Item>
          ))}
        <Menu.Item key={null}>все этажи</Menu.Item>
      </Menu>
    ),
    [floors, handleFloorsMenuClick]
  );
  const clickRoom = useCallback(
    (room) => {
      history.push(
        `/Offices/facilities/${params.facilityId}/rooms/${room.id}/about`
      );
    },
    [params.facilityId, history]
  );

  return (
    <div className={styles.roomsListLayout}>
      <div className={styles.menu}>
        <Input
          onChange={onSearchChange}
          value={search}
          placeholder={'Номер или наименование'}
          suffix={<Icon type="search" />}
          className={styles.searchInput}
        />

        <Dropdown overlay={floorsMenu} trigger={['click']}>
          <Button
            shape={'round'}
            className={styles.chooseDropdown}
            loading={floorsLoading}
          >
            {selectedFloor || 'Этажи'} <Icon type="down" />
          </Button>
        </Dropdown>
        <Dropdown overlay={rentStatesMenu} trigger={['click']}>
          <Button
            shape={'round'}
            className={styles.chooseDropdown}
            loading={rentStatesLoading}
          >
            {selectedState
              ? rentStates.find((rentState) => {
                  return rentState.id === selectedState;
                })?.name
              : 'Статус аренды'}
            <Icon type="down" />
          </Button>
        </Dropdown>
      </div>
      <div>
        <Spin spinning={roomsLoading && !facilityLoading}>
          <FloorsTable
            header={header}
            data={shownRooms}
            rowOnClick={clickRoom}
          />
          <Pagination
            maxPage={maxPage}
            setPageNumber={setCurrentPageNumber}
            currentPageNumber={currentPageNumber}
            firstIndexOnPage={firstIndexOnPage}
            lastIndexOnPage={firstIndexOnPage + shownRooms.length}
            totalAmount={rooms.length}
          />
        </Spin>
      </div>
    </div>
  );
};

export default RoomsList;
